export const locationModalMicrocopy = {
  default: {
    title:
      'We use your build location to determine accurate pricing and availability',
    subtitle: 'Explore plans available where you intend to build:',
    selectedLocationText: "You've set your build location:",
    buttonText: 'Accept',
  },
  pricing: {
    title: 'Get started by choosing your build location',
    subtitle: 'Set your build location to show accurate pricing:',
    selectedLocationText: "You've set your build location:",
    buttonText: 'Customize Your Plan',
  },
  login: {
    title: 'Get started by choosing your build location',
    subtitle: 'Set your build location to show accurate pricing:',
    selectedLocationText: "You've set your build location:",
    buttonText: 'Go To Login',
  },
  lotVision: {
    title: 'Set your location to unlock Lot Vision(TM)',
    subtitle: 'Let us know where you intend to build:',
    selectedLocationText: "You've set your build location:",
    buttonText: 'Get Lot Vision',
  },
  account: {
    title:
      'We use your build location to determine accurate pricing and availability',
    subtitle: 'Explore plans available where you intend to build:',
    selectedLocationText: "You've set your build location:",
    buttonText: 'Accept',
  },
};
